var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('a',{attrs:{"href":"https://www.sgrlucegas.com"}},[_c('img',{attrs:{"alt":"SGR Luce & Gas","src":require("../assets/images/logo.svg")}})])])
}]

export { render, staticRenderFns }